
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 py-12 px-6">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start">
          <div className="mb-8 md:mb-0">
            <Link to="/" className="flex items-center mb-3">
              <img 
                src="/noord-ai.png" 
                alt="Noord AI Logo" 
                className="h-8 w-auto mr-2"
              />
              <span className="text-noordblue font-bold text-xl">Noord AI</span>
            </Link>
            <p className="text-gray-600 text-sm max-w-xs">
              AI-oplossingen voor het Noorden
            </p>
            <p className="text-gray-600 text-sm italic mt-1">
              "Samen een stap naar morgen"
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row space-y-8 md:space-y-0 md:space-x-12">
            <div>
              <h3 className="font-semibold text-gray-800 mb-3">Navigatie</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-600 hover:text-noordblue text-sm">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/diensten" className="text-gray-600 hover:text-noordblue text-sm">
                    Diensten
                  </Link>
                </li>
                <li>
                  <Link to="/prijzen" className="text-gray-600 hover:text-noordblue text-sm">
                    Prijzen
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-gray-600 hover:text-noordblue text-sm">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-600 hover:text-noordblue text-sm">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-gray-800 mb-3">Contact</h3>
              <p className="text-gray-600 text-sm mb-2">
                  Onderdeel van <a 
                  href="https://mhard.nl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-noordblue font-bold"
                >
                  MHard
                </a>
              </p>
              <ul className="space-y-2">
                <li className="text-gray-600 text-sm">
                  E-mail: <a href="mailto:info@noord-ai.nl" className="hover:text-noordblue">info@noord-ai.nl</a>
                </li>
                <li className="text-gray-600 text-sm">
                  Tel: <a href="tel:+31629242783" className="hover:text-noordblue">06 2924 2783</a>
                </li>
                <li className="text-gray-600 text-sm">
                  KvK: 87456613
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-10 pt-6 flex flex-col md:flex-row justify-center md:justify-between items-center">
          <p className="text-gray-500 text-xs">
            &copy; {currentYear} Noord AI. Alle rechten voorbehouden.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              <li>
                <a href="#" className="text-gray-500 hover:text-noordblue text-xs">
                  Privacybeleid
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-noordblue text-xs">
                  Algemene voorwaarden
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
